
<template>
  <div id="app" class="container">
    <br />
    <br />

    <div>
      <div class="row">
        <div class="col-xs-12 text-left" style="margin-top:30px;">
          <div v-if="projectLogo" class="text-right" style="float: left !important;">
            <img :src="projectLogo" class="resize-project-logo-lg" />
          </div>
          <div style="float: left; font-size: 12px; font-family: Times New Roman, Times, serif;">
            Công ty CP TM Thùy Dương - Đức Bình
            <br />18E Cộng Hòa, Phường 4, Quận Tân Binh TPHCM
            <br />MST: 0201240971
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-center"
      style="background-color:#168AD6;font-size: 20px; font-family: Times New Roman, Times, serif; 
      font-weight: bold; text-transform: uppercase;margin-top:15px;color:white;"
    >ĐĂNG KÝ LƯU TRÚ</div>

    <div
      class="text-center"
      style="font-size: 16px; font-family: Times New Roman, Times, serif; text-transform: uppercase;"
    >
      <i>REGISTRATION CARD</i>
    </div>

    <div>
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif;float:left;text-align:right;width:61%;"
      >{{(apartment_lease_back_client_main == "") ? "" : getDateRegister(apartment_lease_back_client_main.client_details.date_created)}}</div>
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif; loat:left;text-align:left;"
      >
        <b style="margin-left:50px;"></b>
        <i></i>
        <b></b>
      </div>
    </div>

    <!-- SỐ PHÒNG/ ROOM No.………...…….…………...……..…. -->
    <div style="margin-top:20px;">
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif;border:1px solid white;float:left;text-align:right;width:61%;"
      ></div>
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif; loat:left;border:1px solid white;text-align:left;"
      >
        <b style="margin-left:50px;">SỐ PHÒNG</b> /
        <i>ROOM No.</i>:
        <b>{{this.item.apartment_booking_detail.booking_code}}</b>
      </div>
    </div>
    <!-- Giờ nhận phòng/ Check in time …..………………..…...…..… -->
    <div style="margin-top:0px;">
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif;border:1px solid white;float:left;text-align:right;width:61%;"
      ></div>
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif; loat:left;border:1px solid white;text-align:left;"
      >
        <b style="margin-left:50px;">Giờ nhận phòng</b> /
        <i>Check in time</i>:
        <b>{{formatDateTime(this.item.apartment_booking_detail.checkin_datetime) }}</b>
      </div>
    </div>

    <div class="col-md-12">
      <table class="table table-condensed" style="table-layout:fixed">
        <tr>
          <td colspan="5">
            Tên khách hàng/
            <i>Guest name</i>
            <br />
            <p
              v-if="apartment_lease_back_client_main == ''"
            >............................................................................................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{apartment_lease_back_client_main.client_details.full_name}}</p>
          </td>
          <td colspan="1">
            Ông/bà
            <i>(Title)</i>
            <br />
            <p v-if="apartment_lease_back_client_main == ''">....................</p>
            <p
              style="margin-left:30px"
              v-else
            >{{apartment_lease_back_client_main.client_details.gender == 0 ? "Ông" : "Bà"}}</p>
          </td>
          <td colspan="4">
            Xác nhận đặt phòng số/
            <i>BK Confirmation#</i>
            <br />
            <p
              v-if="isNull(item.apartment_booking_detail.booking_code)"
            >.....................................................................................</p>
            <p style="margin-left:50px" v-else>{{this.item.apartment_booking_detail.booking_code}}</p>
          </td>
        </tr>
        <tr>
          <td colspan="5">
            Tên công ty hoặc CTDL/
            <i>Company or Travel Agent</i>
            <br />
            <p
              v-if="isNull(item.apartment_booking_detail.company_name)"
            >............................................................................................................</p>
            <p style="margin-left:50px" v-else>{{this.item.apartment_booking_detail.company_name}}</p>
          </td>
          <td colspan="5">
            Số lượng khách/
            <i>Number of Pax:</i>
            <br />
            <p
              style="margin-left:50px"
            >{{this.item.apartment_booking_detail.apartment_lease_back_clients_ids.length}}</p>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            Địa chỉ/
            <i>Adress</i>
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.address)"
            >..................................................................................................................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{apartment_lease_back_client_main.client_details.address}}</p>
          </td>
          <td colspan="4">
            Điện thoại liên hệ/
            <i>Contact No:</i>
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.phone)"
            >.....................................................................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{apartment_lease_back_client_main.client_details.phone}}</p>

            <i>Email:</i>
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.email)"
            >.....................................................................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{apartment_lease_back_client_main.client_details.email}}</p>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            Ngày đến/
            <i>Arrival Date</i>
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.checkin_datetime)"
            >...........................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{formatDate(apartment_lease_back_client_main.client_details.checkin_datetime)}}</p>
          </td>

          <td colspan="2">
            Giờ đến/
            <i>Arrival Time</i>
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.checkin_datetime)"
            >...........................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{formatTime(apartment_lease_back_client_main.client_details.checkin_datetime)}}</p>
          </td>

          <td colspan="2">
            CMND/ CCCD/ PP
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.id_passsport)"
            >...........................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{(apartment_lease_back_client_main.client_details.id_passsport)}}</p>
          </td>

          <td colspan="2">
            Ngày sinh/
            <i>DOB</i>
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.dob)"
            >...........................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{(formatDate(apartment_lease_back_client_main.client_details.dob))}}</p>
          </td>
          <td colspan="2">
            Quốc tịch/
            <i>Nationality</i>
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.country)"
            >...........................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{getCountryName(apartment_lease_back_client_main.client_details.country)}}</p>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            Ngày đi/
            <i>Departure Date</i>
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.checkout_datetime)"
            >...........................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{formatDate(apartment_lease_back_client_main.client_details.checkout_datetime)}}</p>
          </td>

          <td colspan="2">
            Giờ đi/
            <i>Departure Time</i>
            <br />
            <p
              v-if="isNull(apartment_lease_back_client_main) || isNull(apartment_lease_back_client_main.client_details.checkout_datetime)"
            >...........................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{formatTime(apartment_lease_back_client_main.client_details.checkout_datetime)}}</p>
          </td>

          <td colspan="2">
            Loại phòng/
            <i>Room Type</i>
            <br />………………………………
          </td>
          <td colspan="4">
            Giá phòng/
            <i>Room Rate</i>
            <br />
            <p
              v-if="isNull(item.apartment_booking_detail.apartment_mapping_with_booking_ids) || isNull(this.item.apartment_booking_detail.apartment_mapping_with_booking_ids[0].booking_room_rate)"
            >...........................................</p>
            <p
              style="margin-left:50px"
              v-else
            >{{getTotal(this.item.apartment_booking_detail.apartment_mapping_with_booking_ids[0].booking_room_rate, 
            this.item.apartment_booking_detail.sale_off, 
            this.item.apartment_booking_detail.discount, 
            this.item.apartment_booking_detail.apartment_mapping_with_booking_ids[0].payment_duration_factor
            )}} VNĐ</p>
          </td>
        </tr>

        <tr>
          <td colspan="10">
            <b>
              PHƯƠNG THỨC THANH TOÁN/
              <i>PAYMENT TERM</i>
            </b>
            <br />
            <p style="margin-left:10px">
              Hình thức thanh toán/
              <i>My payment will be settled by</i>
            </p>…………………………………………………………………………………………………………………………………………………………………
          </td>
        </tr>

        <tr>
          <td colspan="1">□ CASH</td>
          <td colspan="1">□ AMEX</td>
          <td colspan="1">□ VISA</td>
          <td colspan="1">□ MASTER</td>
          <td colspan="1">□ JCB</td>
          <td colspan="1">□ DEBIT</td>
          <td colspan="2">□ BANK TRANSFER</td>
          <td colspan="2">
            □ OTHERS
            <br />.............................................
          </td>
        </tr>

        <tr>
          <td colspan="2">
            Thẻ tín dụng số/
            Credit Card No
          </td>

          <td colspan="8">
            ..........................................................................
            Ngày hết hạn/
            <i>Expriry Date :</i>
            ..........................................................................
          </td>
        </tr>

        <tr>
          <td colspan="2">
            □ Thanh toán đến
            <i>Charge To :</i>
            <br />
          </td>
          <td colspan="8">………………………………………………………………………………………………………………………………</td>
        </tr>

        <tr>
          <td colspan="2">
            Trạng thái/
            <i>Status</i>
            <br />………………………………
          </td>
          <td colspan="2">
            □ Đã thanh toán/
            <i>Paid</i>
            <br />………………………………
          </td>
          <td colspan="2">
            □ Chưa thanh toán/
            <i>Not Paid</i>
            <br />………………………………
          </td>

          <td colspan="4">
            □ Khác/
            <i>Others</i>
            <br />…………………………………………………………
          </td>
        </tr>

        <tr>
          <td colspan="10">
            <b>
              GHI CHÚ/
              <i>NOTES</i>
            </b>
            <br />…………………………………………………………………………………………………………………………………………………………
            <br />…………………………………………………………………………………………………………………………………………………………
          </td>
        </tr>

        <tr>
          <td colspan="10"></td>
        </tr>

        <tr>
          <td colspan="10">
            <b>
              ƯU Ý ĐẶC BIỆT/
              <i>IMPORTANT</i>
            </b>
            <br />Tòa nhà Republic Plaza sẽ không chịu trách nhiệm cho bất cứ tiền bạc, nữ trang hoặc đồ đạc quý giá mà Quý khách mang vào tòa nhà.
            Quý khách nên cất giữ tất cả những tư trang và tài sản có giá trị vào két sắt mà tòa nhà đã cung cấp.
            <br />
            <i>
              Money, jewels and other valuables are brought to the Republic Plaza at the guest’s sole risk. The Republic Plaza and the Building
              Mangement Office accept no ability and shall not be responsible for any loss or damage
              thereto and guests remain solely responsible for the safekeeping of any such items.
            </i>
          </td>
        </tr>

        <tr>
          <td style="text-align:center" colspan="5">
            <b>KHÁCH HÀNG</b>
            <br />
            <i>GUEST SIGNATURE</i>

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            {{ (apartment_lease_back_client_main == "") ? "" : apartment_lease_back_client_main.client_details.full_name}}
          </td>

          <td style="text-align:center" colspan="5">
            <b>NHÂN VIÊN</b>
            <br />
            <i>RECEPTIONIST SIGNATURE</i>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </td>
        </tr>

        <tr>
          <td style="text-align:center" colspan="10">
            Thời gian trả phòng là 12 giờ trưa /
            <i>Check out time 12 pm (noon)</i>
            <br />Giá trên đã bao gồm thuế và phí/
            <i>Room rate is inclusive of service charge & prevailing government taxes</i>
            <br />
          </td>
        </tr>
      </table>
    </div>

    <br />
    <div class="row">
      <form class="form-horizontal">
        <div class>
          <button
            id="cmdCancel"
            type="button"
            class="btn btn-labeled btn-danger"
            @click="CancelInvoiceList"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label">
              <i class="fa fa-mail-reply"></i>
            </span>
            {{$t('common.back')}}
          </button>
          <button
            id="cmdPrintPdf"
            type="button"
            class="btn btn-labeled btn-warning pull-right"
            @click="printInvoice"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{$t('common.printPdf')}}
          </button>
        </div>
      </form>
    </div>

    <!-- <lte-modal v-show="isModalVisible" @onConfirm="onConfirm" @close="closeModal" v-for="obj in objModal" :key="obj.id" :item="obj"></lte-modal> -->
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
    <router-view></router-view>
  </div>
</template>

<script>
// import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Multiselect from "vue-multiselect";
// import LTEModal from "@/components/LTEModal.vue";
import utils from "@/lib/utils";
// import i18n from "../../lang";
import Loading from "vue-loading-overlay";
import BookingStatusEnum from "@/enum/bookingStatusEnum";
import ProjectStatusEnum from "@/enum/projectStatusEnum";

export default {
  name: "ApartmentLeasebackClientsPrintPdf",
  data() {
    return {
      projectLogo: null,
      // initialize data for not error
      // item will get again
      item: {
        apartment_booking_detail: {
          id: 1,
          apartment_lease_back_clients_ids: [],
          apartment_mapping_with_booking_ids: [],
          company_tax_code: "0",
          booking_company_details: null,
          date_created: "2019-12-03T07:01:12.829264Z",
          date_updated: "2019-12-18T00:30:31.986039Z",
          date_deleted: null,
          booking_code: "RPSA-1219000001",
          other_booking_details: "",
          checkin_datetime: "2019-12-14T23:00:00Z",
          checkout_datetime: "2020-01-01T15:00:00Z",
          checkin_yn: false,
          booking_person_name: "NGUYỄN THỊ HẠNH",
          booking_person_email: "test@gmail.com",
          booking_person_phone: "0000000000",
          deposit: 0,
          deposit_deadline: "2019-12-08T00:00:00Z",
          payment_in_advance: 0,
          discount: 0,
          sale_off: 0,
          ew_included: false,
          deposit_request: 10285000,
          payment_inadvance_request: 20570000,
          company_name: "",
          company_address: "",
          company_email: "",
          booking_company: null,
          booking_status: BookingStatusEnum.CONFIRMED
        },
        project_detail: {
          address: "18E Cong Hoa, Ward. 4, Tan Binh Dist., HCMC",
          website: "www.republicplaza.vn",
          phone: "(84.28) 71077388",
          project_name: "Republic",
          email: "info@republicplaza.vn",
          banktransfer: {
            id: 1,
            date_created: "2019-01-16T06:00:00Z",
            date_updated: "2019-01-16T06:00:00Z",
            date_deleted: null,
            bank_other_details: "CN Cộng Hòa",
            bank_account_no: "006704078181818",
            bank_account_name:
              "Công ty Cổ phần Thương mại Thùy Dương - Đức Bình",
            bank_transferring_content:
              "Căn hộ ......... Republic Plaza + Thanh toán tiền điện, nước tháng .........",
            bank_contact_us: "(028) 71077388 - 0989845404",
            is_active: true,
            project: {
              id: 1,
              date_created: "2019-01-16T06:00:00Z",
              date_updated: "2019-01-16T06:00:00Z",
              date_deleted: null,
              project_name: "Republic",
              project_code: "RPP",
              project_description: "",
              project_start_date: "2019-01-16T06:00:00Z",
              operator_name: "Republic",
              operator_address: "18E Cong Hoa, Ward. 4, Tan Binh Dist., HCMC",
              operator_telephone: "(84.28) 71077388",
              operator_website: "www.republicplaza.vn",
              monthly_calculate_period_start: 26,
              monthly_calculate_period_end: 25,
              monthly_data_input_period_start: 26,
              monthly_data_input_period_end: 1,
              monthly_due_date: 5,
              date_view_options: "DD/MM/YYYY",
              sa_default_e_fee: null,
              sa_default_w_fee: null,
              project_status: ProjectStatusEnum.ACTIVE
            },
            bank_code: {
              id: 9,
              date_created: "2019-08-27T16:14:00Z",
              date_updated: "2019-08-27T16:14:00Z",
              date_deleted: null,
              bank_name: "HD Bank - HDBank",
              bank_code: "HDBank"
            }
          }
        }
      },
      apartment_lease_back_client_main: "",
      isLoading: false,
      country_list: [],
    };
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    number_of_days: function() {
      let checkin = utils.formatSqlDate(this.item.apartment_booking_detail.checkin_datetime, "YYYY-MM-DDTHH:mm:ss.sssZ", "MM/DD/YYYY");
      let checkout = utils.formatSqlDate(this.item.apartment_booking_detail.checkout_datetime, "YYYY-MM-DDTHH:mm:ss.sssZ", "MM/DD/YYYY");
      let number_of_days =
        utils.datediff(checkin, checkout) == "NaN"
          ? 0
          : utils.datediff(checkin, checkout);
      return number_of_days;
    },

    getTotal: function(
      booking_room_rate,
      sale_off,
      discount,
      payment_duration_factor
    ) {
      let booking_room_rate_discount = booking_room_rate * (1 - sale_off / 100);
      let package_summary =
        (booking_room_rate_discount /
          (payment_duration_factor == 1
            ? 30
            : payment_duration_factor == 2
            ? 7
            : 1)) *
          this.number_of_days() -
        discount;

      return utils.formatNumber(Math.round(package_summary));
    },

    isNull(val) {
      return utils.isNull(val);
    },

    getCountryName: function(country_id) {
      if (country_id == null) return "";
      for (let i = 0, size = this.country_list.length; i < size; i++) {
        if (country_id == this.country_list[i].value) {
          return this.country_list[i].text;
        }
      }
    },
    stringGen(len) {
      let text = "";
      for (var i = 0; i < len; i++) text += ".";

      return text;
    },
    generalDot(val, max_len) {
      if (utils.isNull(val)) return this.stringGen(max_len);

      let len_gen_dot = (max_len - utils.byteLength(val)) / 2;
      return this.stringGen(len_gen_dot) + val + this.stringGen(len_gen_dot);
    },

    formatDate(date) {
      return utils.addTimeZoneForTimestamp(date, "DD/MM/YYYY");
    },
    formatDateTime(date) {
      return utils.addTimeZoneForTimestamp(date, "DD/MM/YYYY  HH:mm:ss");
    },
    formatTime(date) {
      return utils.addTimeZoneForTimestamp(date, "HH:mm:ss");
    },

    formatCurrent(val) {
      return utils.formatNumber(val);
    },

    getDateRegister(date) {
      // Day
      let day = utils.formatSqlDate(date, null, "DD");
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");

      return `Ngày/ date ${day} tháng/ month ${month} năm/ year ${year}`;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_BOOKING_DETAIL",
      "GET_COUNTRY_LIST"
    ]),

    CancelInvoiceList: function() {
      this.$router.push({
        name: "ReceiptList"
      });
    },

    onConfirm: function() {
      this.isModalVisible = false;
    },

    printInvoice: function() {
      document.getElementById("cmdCancel").style.display = "none";
      document.getElementById("cmdPrintPdf").style.display = "none";
      window.print();
      document.getElementById("cmdCancel").style.display = "";
      document.getElementById("cmdPrintPdf").style.display = "";
    },

    async getBookingDetails() {
      let booking_id = parseInt(this.$route.params.id);

      await this.GET_BOOKING_DETAIL({ id: booking_id }).then(
        function(res) {
          let booking_data = res.data;
          this.item = booking_data;
          let array_apartment_lease_back_clients = booking_data.apartment_booking_detail.apartment_lease_back_clients_ids.filter(
            item => item.main_contact == true
          );
          if (array_apartment_lease_back_clients.length > 0) {
            this.apartment_lease_back_client_main =
              array_apartment_lease_back_clients[0];
          }
        }.bind(this)
      );
    }
  },
  async mounted() {
    this.isLoading = true;
    this.projectLogo = sessionStorage.getItem('projectLogo')
    this.GET_COUNTRY_LIST().then(
      function(res) {
        let countries = [
          {
            value: null,
            text: "---"
          }
        ];
        let data = res.data;
        data.forEach(c => {
          let country = {
            value: c.id,
            text: c.country_name
          };
          countries.push(country);
        });
        this.country_list = countries;
      }.bind(this)
    );

    await this.getBookingDetails();
    this.isLoading = false;
  },
  components: {
    // Multiselect,
    // "lte-modal": LTEModal
    loading: Loading
  }
};
</script>

<style scoped>
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}

.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}

.btn {
  margin-bottom: 10px;
}

.table_total_fee {
  border: 2px solid #000000;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
  border: 2px solid #000000;
}

.container {
  font-family: Times New Roman, Times, serif !important;
}

body {
  font-size: 12px !important;
}
.resize-project-logo-lg {
  height: auto;
  width: auto;
  max-width: 80px;
  max-height: 60px;
}
@media print {
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
/* remove title when print */
@page {
  size: auto;
  margin: 0mm;
}

.table_column_en {
  font-style: italic;
  font-weight: 100;
}

table {
  border: 3px solid #000000;
  border-collapse: collapse;
}

td {
  padding: 5px;
  border: 1px solid !important;
}
</style>






// WEBPACK FOOTER //
// src/views/Apartment/ApartmentLeasebackClientsPrintPdf.vue